export * from "./short-display-name";

import { z } from "zod";

export const reviewSchema = z.object({
  id: z.string(),
  authorName: z.string(),
  rating: z.number().int().min(1).max(5),
  body: z.string(),
  createdAt: z.string(),
  images: z.array(z.string().url()).default([]),
});
export type Review = z.infer<typeof reviewSchema>;

export const reviewFilterSchema = z.enum([
  "most_relevant",
  "with_images",
  "4_plus_stars",
  "3_stars",
  "below_3",
]);
export type ReviewFilter = z.infer<typeof reviewFilterSchema>;

export const postReviewSchema = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  email: z.string().email(),
  review: z.string().min(1),
  activityId: z.string(),
  rating: z.number().int().min(1).max(5),
  currency: z.string(),
});
export type PostReviewRequest = z.infer<typeof postReviewSchema>;

export const submitReviewRequestSchema = z.object({
  reservation_id: z.string(),
  rating: z.number().int().min(1).max(5),
  body: z.string().min(10).max(500),
  // images uploaded as multipart files; request schema lists filenames only
  imageCount: z.number().int().min(0).max(6),
});
export type SubmitReviewRequest = z.infer<typeof submitReviewRequestSchema>;

export const reviewImpactSchema = z.object({
  reviews_written: z.number().int().nonnegative(),
  people_helped: z.number().int().nonnegative(),
});
export type ReviewImpact = z.infer<typeof reviewImpactSchema>;

export const submitReviewResponseSchema = z.object({
  review: reviewSchema,
  points_earned: z.number().int().nonnegative(),
  updated_points_balance: z.number().int().nonnegative(),
  impact: reviewImpactSchema,
});
export type SubmitReviewResponse = z.infer<typeof submitReviewResponseSchema>;
